import React, { useCallback, useEffect, useState } from 'react';
import axiosInstance from "../../api/axiosInstance";
import "../sidebar/sidebar.scss"
import { Link } from 'react-router-dom';

const Sidebar = () => {
    const [suggestions, setSuggestions] = useState([]);

    const fetchData = useCallback(async () => {
        try {
            const [suggestionsRes] = await Promise.all([
                axiosInstance.get('events')
            ]);
            setSuggestions(suggestionsRes.data);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <div className="sidebar">
            <div className="box">
                <h4>Vorschläge für Dich</h4>
                <div className="list">
                    {suggestions.map((item) => (
                        <Link className="item" key={item.id} to={"/profile/" + item.username}>
                                <div className="image">
                                    <img src={"https://api.kolhaupt.it/uploads/" + item.profile_img} alt="" />
                                </div>
                                <div className="data">
                                    <span className="name">{item.profile_name}</span>
                                    <span className="location">{item.location_name}</span>
                                </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
